module.exports = __webpack_public_path__ + "img/0C430C_257D25_439A43_3C683C-256px.2fa17a20.png";